import axios from "axios";

const publicApi = axios.create({
  baseURL: "https://apizeus.slapie.com.br/api",
  // baseURL: "http://localhost:8001/api",
});

const submitLead = async (data) => {
  return await publicApi.post("/leads/", data, {
    headers: { "Content-Type": "application/json" },
  });
};

const completeLead = async (leadId, data) => {
  return await publicApi.patch(`/leads/${leadId}/complete/`, data, {
    headers: { "Content-Type": "application/json" },
  });
};

const LeadService = {
  submitLead,
  completeLead,
};

export default LeadService;
